var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAlibaba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_2831",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3H0V13H16V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_2831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.175 3.05675C1.79133 3.14769 1.43036 3.31626 1.11434 3.55205C0.798314 3.78784 0.533935 4.08587 0.3375 4.42775C0.012 5.06625 0 5.22325 0 7.911C0 9.34525 0.025 10.5265 0.06 10.711C0.164556 11.2459 0.426247 11.7376 0.811627 12.123C1.19701 12.5085 1.68857 12.7703 2.2235 12.875C2.555 12.935 6.86975 12.9655 6.86975 12.9C6.86975 12.8517 6.50225 11.4055 6.484 11.3875C6.478 11.3755 5.7125 11.2067 4.784 11.0075C2.6205 10.5375 2.684 10.5555 2.506 10.3385L2.35 10.15V5.775L2.50675 5.585C2.6875 5.368 2.62125 5.385 4.78475 4.916L6.48475 4.536C6.5025 4.52375 6.87 3.07725 6.87 3.03175C6.87 2.975 2.465 3.00175 2.175 3.06175V3.05675ZM9.16 3.06575C9.166 3.175 9.5035 4.5 9.54 4.53625C9.552 4.55425 10.3775 4.74125 11.365 4.952C12.3525 5.16275 13.2332 5.377 13.3115 5.422C13.4179 5.48345 13.5073 5.57039 13.5717 5.675C13.6683 5.84375 13.6803 6.025 13.6803 7.965C13.6803 9.905 13.6683 10.0862 13.5717 10.255C13.506 10.3582 13.4173 10.4448 13.3125 10.508C13.2343 10.5505 12.3625 10.761 11.366 10.978L9.541 11.3967C9.50475 11.433 9.16725 12.7587 9.161 12.8672C9.161 12.9335 9.595 12.9455 11.4993 12.9272C14.1243 12.9022 14.1568 12.8972 14.8258 12.4452C15.3063 12.1146 15.6693 11.6397 15.8623 11.0892C16 10.6855 16 10.65 16 7.9675C16 5.285 16 5.25 15.8612 4.84575C15.6682 4.29538 15.3054 3.82054 14.825 3.48975C14.1558 3.03825 14.125 3.03175 11.4983 3.008C9.594 2.99 9.16 3 9.16 3.068V3.06575ZM6.47 7.84075C6.45049 7.90557 6.44638 7.97406 6.458 8.04075C6.476 8.14075 6.5845 8.14925 8.0005 8.16725L9.51925 8.17925V7.75675H8.015C6.7555 7.75675 6.49625 7.76875 6.4725 7.841L6.47 7.84075Z",
    fill: "#EE722E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlibaba);
export default __webpack_public_path__ + "static/media/Logo_alibaba.3ca58efbd8ac068ceb98e93697352721.svg";
export { ForwardRef as ReactComponent };